export interface StyleCategory {
  name: string;
  fonts: string[];
}

export const fontStyleCategories: StyleCategory[] = [
  {
    name: "Handwritten / Script",
    fonts: [
      "ThitSarShweSi",
      "MasterpieceLakwel",
      "MasterpieceUniHand",
      "MasterpieceYayChanZin"
    ]
  },
  {
    name: "Sans-Serif / Clean UI",
    fonts: [
      "MyanmarAngoun",
      "MyanmarGantgaw",
      "MyanmarNayone",
      "MyanmarNjaun",
      "MyanmarPauklay",
      "MyanmarPhetsot",
      "MyanmarSabae",
      "MyanmarSagar",
      "MyanmarSanpya",
      "MyanmarTagu",
      "MyanmarThuriya",
      "MyanmarWaso",
      "MyanmarYinmar",
      "MyanmarSansPro",
      "Myanmar3",
      "NotoSanMyanmar",
      "NotoSansMyanmarUI",
      "NotoZawDecode",
      "Pyidaungsu",
      "Ours-Unicode",
      "Yunghkio",
      "MyMyanmarUniversal",
      "Mon3",
      "NamKhoneUnicode",
      "NKSSmart2",
      "NKSSmart3",
      "NKSSmart4",
      "CherryUnicode",
      "Kamjing",
      "Yangon"
    ]
  },
  {
    name: "Serif / Traditional",
    fonts: [
      "MasterpieceTawWin",
      "MasterpieceUniSerif",
      "NotoSerifMyanmar"
    ]
  },
  {
    name: "Rounded",
    fonts: [
      "MasterpieceUniRound",
      "MasterpieceDaungRound"
    ]
  },
  {
    name: "Square / Blocky",
    fonts: [
      "MyanmarChatu",
      "MyanmarChatuLight",
      "MyanmarKhyay",
      "MyanmarKuttar",
      "MyanmarPonenyet",
      "MyanmarSquare",
      "MyanmarSquareLight"
    ]
  },
  {
    name: "Typewriter / Monospaced",
    fonts: [
      "MasterpieceUniType"
    ]
  },
  {
    name: "Display / Decorative",
    fonts: [
      "MasterpieceCTL",
      "MasterpieceSpringRev",
      "MasterpieceStadium",
      "MasterpieceDaung",
      "MyanmarPhiksel",
      "MyanmarBlack",
      "MyanmarHeadOne",
      "YoeYar-One"
    ]
  }
];
